export const PHOTO_UPLOADS_BY_CREATOR = "/photo-uploads/by-creator/";
